"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteComment = deleteComment;
exports.listComment = listComment;
var _request = _interopRequireDefault(require("@/utils/request"));
function listComment(query) {
  return (0, _request.default)({
    url: '/comment/list',
    method: 'get',
    params: query
  });
}
function deleteComment(data) {
  return (0, _request.default)({
    url: '/comment/delete',
    method: 'post',
    data: data
  });
}